import { login, logout } from "@/api/modules/base";
import { getLoggedUserInfo } from "@/api/modules/user";
import { Notification, Message } from "element-ui";
import { recordRoute, title } from "@/setting.config";
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from "@/utils/accessToken";
import router from "@/router";
import store from "@/store";
import i18n from "@/lang";
import { info } from "sass";

const state = () => ({
  // info: {
  //   id: "",
  //   name: "",
  //   account: "",
  //   avatar: "",
  // },
  info: null,
  org: [],
  post: [],
  masterOrgPost: {},
  accessToken: getAccessToken(),
  todoCount: 0,
  wxUserId: "",
});
const getters = {
  accessToken: (state) => state.accessToken,
  id: (state) => state.info.id,
  name: (state) => state.info.name,
  avatar: (state) => state.info.avatar,
  todoCount: (state) => state.todoCount,
  info: (state) => state.info,
  wxUserId: (state) => state.wxUserId,
};
const mutations = {
  setTodoCount(state, todoCount) {
    state.todoCount = todoCount;
  },
  resetAccessToken(state) {
    state.accessToken = "";
    removeAccessToken();
  },
  setAccessToken(state, token) {
    state.accessToken = token;
    setAccessToken(token);
  },
  setInfo(state, info) {
    state.info = info;
  },
  setWxUserId(state, wxUserId) {
    state.wxUserId = wxUserId;
  },
};
const actions = {
  setUserInfo({ commit }, info) {
    commit("setInfo", info);
  },
  setWxUserId({ commit }, wxUserId) {
    commit("setWxUserId", wxUserId);
  },
  // 账号密码登录
  async login({ dispatch, commit, state }, loginInfo) {
    console.log("开始登录...1");
    const res = await login(loginInfo);
    console.log("resres", res);
    if (res?.code === 200 || ("操作成功" === res?.msg && res?.redirect_uri)) {
      console.log("denglu", res?.code);
      localStorage.setItem("accountInfo", JSON.stringify(res));
      commit("setInfo", res.data);
    } else {
      Message.error(`登录接口异常，未正确返回token...`);
      // return;
    }

    // const accessToken = res.value
    // if (accessToken) {
    //   commit('setAccessToken', accessToken)
    // } else {
    //   // Message.error(
    //   //   `登录接口异常，未正确返回token...`)
    //   // return
    // }
    // dispatch("loadUserInfo");
    // const hour = new Date().getHours();
    // const thisTime =
    //   hour < 8
    //     ? i18n.t("user.moring")
    //     : hour <= 11
    //     ? i18n.t("user.moring")
    //     : hour <= 13
    //     ? i18n.t("user.noon")
    //     : hour < 18
    //     ? i18n.t("user.afternoon")
    //     : i18n.t("user.evening");
    // Notification.success(`欢迎登录${title} ${thisTime}！`)
  },
  // 加载用户信息
  // async loadUserInfo({dispatch, state}) {
  //   const res = await getLoggedUserInfo()
  //   const {user, postList, orgList, masterOrgPost} = res.value
  //   if (user) {
  //     state.info.id = user.id
  //     state.info.name = user.fullname
  //     state.info.account = user.account
  //     state.info.avatar = user.ext?.avatar
  //   } else {
  //     Message.error(
  //       `用户数据异常，未正确返回用户信息...`)
  //     return
  //   }
  //   state.post = postList
  //   state.org = orgList
  //   state.masterOrgPost = masterOrgPost
  // },
  async logout({ dispatch, commit, state }) {
    commit("resetAccessToken");
    if (state.info) {
      state.info.id = "";
      state.info.name = "";
      state.info.account = "";
    }
    state.post = [];
    state.org = [];
    state.masterOrgPost = {};
    store.commit("authItems/cleanAuthItems");
    store.commit("tabsBar/delAll");
    // let routeUrl = router.push({
    //   path: "/Home",
    // });
    const isMobile = store.getters["app/isMobileMode"];
    debugger;
    if (isMobile) {
      router.push({
        path: "/h5/Home",
      });
    } else {
      router.push({
        path: "/Home",
      });
    }
    // location.href = routeUrl.href;
    localStorage.removeItem("accountInfo");
    commit("setWxUserId", "");
    commit("setInfo", null);
    logout();
    // window.location.reload();
  },
  wxauthorization() {
    const allConfig = JSON.parse(localStorage.getItem("allConfig"));
    if (allConfig) {
      const appid =
        allConfig.find((item) => item.key === "wx.mp.appid")?.value || "";
      const redirectUri = encodeURIComponent(
        `https://ywtb.cqtc.edu.cn/loginLoading`
      );
      const scope = "snsapi_userinfo";
      const state = Math.random().toString(36).substring(2, 10); // 随机state
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.href = authUrl;
    }
  },
};
export default { state, getters, mutations, actions };
